export default {
  //微信appid
  appid: function () {
    //return 'wx417bfa6f6ccf884a'
    return 'wx8de47988f85f5b8a'//正式
  },
  wxIndex: function () {
    // return '1'
    return '3'//正式
  },
  //获取网址路径
  curWebUrl: function () {
    return document.location.origin
  },
  //数组json排序
  arrJsonSort: function (data) {
    data.sort(sortNumber)

    function sortNumber (a, b) {
      return a.sort - b.sort
    }

    return data
  },
  //获取顶级域名
  curDomain: function () {
    let curWwwPath = window.document.location.href
    curWwwPath = curWwwPath.replace(/.+[\.\/]([A-z]+\.[A-z]+)\/[^\/].+/, '$1')
    return curWwwPath
  },
  //清除所有cookie函数
  clearAllCookie: function () {
    let keys = document.cookie.match(/[^ =;]+(?=\=)/g)
    if (keys) {
      for (let i = keys.length; i--;) {
        document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
      }
    }
    // console.log('清除所有缓存')
  },
  //默认cookie时间
  cookieTime: function () {
    return '24h' //单位:小时
  },
  //接口地址
  webName: function () {
    return '现代教育 - '
  },
  //时间戳转换
  TimeTrans: function (time, format) {
    console.log("sssssssssssssssssssssssssssssssssss",time, format)
    var date = new Date(time)
    var Y = date.getFullYear() + '-'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ''
    var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
    if (format == 'hm') {
      return Y + M + D + h + m
    } else if (format == 'day') {
      return Y + M + D
    } else if (format == 'md') {
      return M + D
    } else {
      return Y + M + D + h + m + s
    }
  },
  //接口地址
  api: function () {
    return '/api'
  },
  //缩略图
  ossThumb: function () {
    return '-thumb'
  },
  //视频缩略图
  ossVideoThumb: function () {
    return '?x-oss-process=video/snapshot,t_30000,m_fast'
  },
  //截取字符
  interceptCharacter: function (state, obj, character) {
    let index = obj.lastIndexOf(character)
    if (state == 'front') {
      obj = obj.substring(0, index)
    } else if (state == 'after') {
      obj = obj.substring(index + 1, obj.length)
    }
    return obj
  },
  //随机生成字符串
  randomString: function (len) {
    len = len || 32
    let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    let maxPos = chars.length
    let encrypt = ''
    for (i = 0; i < len; i++) {
      encrypt += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return encrypt
  },
  //生成随机数
  randomNumMinMax: function (minNum, maxNum) {
    switch (arguments.length) {
      case 1:
        return parseInt(Math.random() * minNum + 1)
        break
      case 2:
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum)
        break
      default:
        return 0
        break
    }
  }

}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js